import {AppPermissions, FormlyTextTemplateConfig} from "@app/core-shared";
import {TechPortalFeatureTextTemplateEditComponent} from "@app/tech-portal/features/templates/src/lib/components";

export function provideFormlyTextTemplateConfig(): FormlyTextTemplateConfig[] {
  return [
    {
      editComponent: TechPortalFeatureTextTemplateEditComponent,
      createPermission: AppPermissions.CreateTemplate,
      editPermission: AppPermissions.UpdateTemplate,
      readPermission: AppPermissions.ReadTemplate,
      createTitle: 'core-portal.settings.actions.templates.create-text-template',
      editTitle: 'core-portal.settings.actions.templates.edit-text-template'
    }
  ];
}
